import Analytics from "../Analytics";
import get from "lodash/get";
import forEach from "lodash/forEach";
import isArray from "lodash/isArray";
import { BRANCH_IO_WHITELISTED_TRIGGERS } from "../../constants/AnalyticsTypeConstants";
import { sendAnalyticsDataToApp } from "utils/helpers";
import { constructBranchIOEventData } from "analytics/utils/branchIOAnalytics/branchIOAnalyticsHelpers";

export const submitEventDataToBranchIO = (data = {}) => {
  sendAnalyticsDataToApp(data);
};

class BranchIOAnalytics extends Analytics {
  pushEvent(event, data, message, reduxStore) {
    /**
     * Push events to BranchIO
     * @param {string} event type of event triggered based on user actions, page load and etc.
     * @param {object} data data associated with triggered event
     */
    this.pushBranchIOEvent(event, data, message, reduxStore);
  }

  pushBranchIOEvent(triggerKey, data, message, reduxStore) {
    if (BRANCH_IO_WHITELISTED_TRIGGERS[triggerKey]) {
      const ecommerceEventData = constructBranchIOEventData(
        triggerKey,
        data,
        reduxStore
      ); // can be array or object, depending on whether multiple events need to be fired on one trigger
      if (isArray(ecommerceEventData)) {
        // Scenarios where trigger has more than one event data to push
        forEach(ecommerceEventData, eventData => {
          if (get(eventData, "branch_standard_event")) {
            submitEventDataToBranchIO(eventData);
          }
        });
      } else {
        // Scenarios where trigger only has one event data to push
        if (get(ecommerceEventData, "branch_standard_event")) {
          submitEventDataToBranchIO(ecommerceEventData);
        }
      }
    }
  }
}

export default new BranchIOAnalytics();
